import script from "./JobCard.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCard.vue?vue&type=script&setup=true&lang=js"

import "./JobCard.vue?vue&type=style&index=0&id=7d139308&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d139308"]])

export default __exports__